import React, { useEffect, useRef, useState } from "react";
import "./Carousel.scss";
import star from "../../assets/star.svg"
const Carousel = ({ items }) => {
    const itemsPerPage = 4;
    const totalPages = Math.ceil(items.length / itemsPerPage);
    const [currentIndex, setCurrentIndex] = useState(0);
    const wrapperRef = useRef(null);

    // Auto-scroll
    useEffect(() => {
        if (window.screen.width > 900) {
            const interval = setInterval(() => {
                setCurrentIndex((prev) => (prev + 1) % totalPages);
            }, 3000);
            return () => clearInterval(interval);
        }
    }, [totalPages]);

    useEffect(() => {
        if (wrapperRef.current) {
            if (window.screen.width > 900) {
                const cardWidth = wrapperRef.current.offsetWidth / itemsPerPage;
                wrapperRef.current.scrollTo({
                    left: cardWidth * itemsPerPage * currentIndex,
                    behavior: "smooth",
                });
            }
        }
    }, [currentIndex, itemsPerPage]);

    return (
        <div className="hoppers-carousel-container">
            <div className="hoppers-carousel-wrapper" ref={wrapperRef}>
                {items.map((item, idx) => (
                    <div className="hoppers-carousel-card" key={idx}>
                        <div className="hoppers-carousel-card-top">
                            <img
                                alt=""
                                src={item?.image} />
                            <div className="hoppers-carousel-card-top-right">
                                <div className="hoppers-carousel-card-top-right-name">{item?.name}</div>
                                <div className="hoppers-carousel-card-top-right-designation">{item?.designation}</div>

                            </div>
                        </div>
                        <div className="hoppers-carousel-card-rate">
                            {[...Array(item?.rate)].map((_, key) => {
                                return (
                                    <img alt="" src={star} key={key} />
                                )
                            })}
                        </div>
                        <div className="hoppers-carousel-card-review">
                            {item?.review}
                        </div>
                    </div>
                ))}
            </div>

            {totalPages.length > 1 && window.screen.width > 900 && <div className="hoppers-carousel-dots">
                {Array.from({ length: totalPages }).map((_, idx) => (
                    <span
                        key={idx}
                        className={`dot ${idx === currentIndex ? "active" : ""}`}
                        onClick={() => setCurrentIndex(idx)}
                    />
                ))}
            </div>}
        </div>
    );
};

export default Carousel;
